/** Preferred general town URLs; legacy pages stay accessible until hosting supports HTTP 301s. */
export const PRIMARY_TOWN_PATHS: Record<string, string> = {
  "/wayne-nj/": "/painters-wayne-nj/",
  "/paramus-nj/": "/painters-paramus-nj/",
  "/mahwah-nj/": "/painters-mahwah-nj/",
  "/ridgewood-nj/": "/painters-ridgewood-nj/",
  "/montclair-nj/": "/painters-montclair-nj/",
};

export const primaryTownPath = (path: string) => {
  const normalized = path.endsWith("/") ? path : `${path}/`;
  return PRIMARY_TOWN_PATHS[normalized] || normalized;
};